"use strict";
window.theme = window.theme || {}
theme.quickNewsletterForm = function() {
    function quickNewsletterForm() {

        this.btn = {
            follow_newsletter: document.querySelectorAll('.follow__us__btn__newsletter'),
            close: document.querySelectorAll('.quick-newsletter-form__close'),
            successClose: document.querySelectorAll('.newsletter-close'),
            overlay: document.querySelectorAll('.quick-newsletter-form__overlay')
        }
        this.container = {
            quick_drawer: document.querySelector('.quick-newsletter-form'),
            country_list: document.querySelectorAll('[name="contact[country]"]'),
            confirmation: document.querySelector('.quick-newsletter-form-submit-status'),
            body: document.querySelector('body'),
            success_wrap: document.querySelector('.success-wrap'),
            newsletter_text: document.querySelector('.newsletter__text'),
            newsletter_form_inner: document.querySelector('.newsletter-form-inner')
        }

        this.load();

    }
    quickNewsletterForm.prototype.load = function() {
        var _ = this;
        _.btn.follow_newsletter.forEach(element => {
            element.addEventListener('click', () => {
                _.opendrawer();
            })
        })
        _.btn.close.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
                if(document.URL.endsWith("#nl-sign-up") ){
                  window.history.replaceState(null,null," ")
                }
            })
        })
        _.btn.successClose.forEach(element => {
          element.addEventListener('click', () => {
              _.closedrawer();
          })
        })
        _.btn.overlay.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
                if(document.URL.endsWith("#nl-sign-up") ){
                  window.history.replaceState(null,null," ")
                }
            })
        })
        if(_.container.country_list.length>0) {
          _.container.country_list.forEach(function(select) {
            _.repopulatecountry(select);
          });
        }
        if(_.container.confirmation.value === 'false' && _.getdrawerstatus('quickNewsletterForm') === 'close') {
            _.container.quick_drawer.classList.remove('success');
            _.closedrawer();
        }
        if(_.container.confirmation.value === 'true' && _.getdrawerstatus('quickNewsletterForm') === 'open') {
            _.container.quick_drawer.classList.add('success');
            _.opendrawer();
        }
    }

    quickNewsletterForm.prototype.opendrawer = function() {
        var _ = this;
        _.container.quick_drawer.classList.add('active');
        _.container.quick_drawer.classList.add('visible');

        _.container.success_wrap.style.display = "none";
        _.container.newsletter_text.style.display = "block";
        _.container.newsletter_form_inner.style.display = "flex";
        _.container.body.style.top = `-${window.scrollY}px`;
        _.container.body.style.width = '100%';
        _.container.body.style.position = 'fixed';
        document.addEventListener("DOMContentLoaded", () => {
          setTimeout( () => {
            document.body.style.setProperty('padding-right', '6px');
          }, 1000);
        });
        _.setdrawerstatus('open');
    }

    quickNewsletterForm.prototype.closedrawer = function() {
        var _ = this;
        _.container.quick_drawer.classList.remove('active');
        _.container.quick_drawer.classList.remove('visible');
        
        const scrollY = document.body.style.top;
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        _.setdrawerstatus('close');
        _.container.quick_drawer.classList.remove('success');
        if(_.container.confirmation.value === 'true') {
            window.location = window.location.pathname; //require refresh the page to remove successfull post param
        }
    }

    quickNewsletterForm.prototype.repopulatecountry = function() {
        var _ = this;
        var select = arguments[0];
        if (!select) return false;
        if(select.getAttribute('data-location') == null) {
          return false;
        }
        fetch(select.getAttribute('data-location'), {
          method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
          if(data.length>0) {
            data.forEach((country) => {
              let newOption = new Option(country.name, country.name);
              select.add(newOption,undefined);
            })
            select.selectedIndex = 0;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    quickNewsletterForm.prototype.setdrawerstatus = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'quickNewsletterForm' + "=" + cvalue + ";" + expires + ";path=/";
    }
    quickNewsletterForm.prototype.getdrawerstatus = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "close";
    }

  theme.quickNewsletterForm = new quickNewsletterForm;

}

theme.quickNewsletterForm();

(function(){

  document.querySelectorAll('.close-this-newsletter').forEach(btn => {
    btn.addEventListener('click', function() {
      const popupNewsletters = document.querySelectorAll('.popup-newsletter');
      popupNewsletters.forEach(popup => {
        popup.classList.remove('visible');
      });
    });
  });
  const dropdowns = document.querySelectorAll('.newsLetterFormCountryDropdown');
  const selectFieldEl = document.querySelectorAll('.select__field');
  dropdowns.forEach(dropdown => {
    dropdown.querySelectorAll('option').forEach((item) => {
      dropdown.removeChild(item);
    });
    repopulateStates(dropdown.closest('form'));
    dropdown.addEventListener('change', function() {
      repopulateStates(dropdown.closest('form'));
    });
  });

  selectFieldEl.forEach((el) => {
    if (el.value !== '') {
      el.classList.add("on");
    }
    el.addEventListener('click', (e) => {
      e.target.classList.add("on");
    })
    el.addEventListener('focusout', (e) => {
      
      if (e.target.value === '') {
        e.target.classList.remove("on");
      } else {
        e.target.classList.remove("error");
        if (e.target.parentElement.querySelector('.error-message')) 
          e
            .target
            .parentElement
            .querySelector('.error-message')
            .remove();
        
      }
    });
    el.addEventListener('change', (e) => {
      
      if (e.target.value === '') {
        e.target.classList.remove("on");
      } else {
        e.target.classList.remove("error");
        if (e.target.parentElement.querySelector('.error-message')) 
          e
            .target
            .parentElement
            .querySelector('.error-message')
            .remove();
        
      }
    });
  })
  fetch('https://cdn.shopify.com/s/files/1/0628/2002/4573/files/country_list_en.json?v=1709632909')
  .then(response => response.json())
  .then(countries => {
    fetch("/browsing_context_suggestions.json")
    .then(result => result.json())
    .then((data) => {
      const currentCountry = data.detected_values.country_name;
      const getRegExp = new RegExp(currentCountry);
      dropdowns.forEach(dropdown => {
        if(currentCountry.includes(dropdown.closest('form'), "United States")){
          repopulateStates(dropdown.closest('form'), "United States of America");
        }else{
          repopulateStates(dropdown.closest('form'));
        }
        countries.forEach((entry, key) => {
          if ( getRegExp.test(entry.name) ) {
            dropdown.insertAdjacentHTML("beforeend",`<option value="${entry.name}" selected="selected">${entry.name}</option>`);
            dropdown.classList.add("on");
          } else {
            if(entry.name == "China (Mainland)"){
              dropdown.insertAdjacentHTML("beforeend",`<option value="China">${entry.name}</option>`);
            }else{
              dropdown.insertAdjacentHTML("beforeend",`<option value="${entry.name}">${entry.name}</option>`);
            }
          }
        });
      });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  const inputFieldEl = document.querySelectorAll(".input_field input");
  const contactEmailInput = document.querySelector("#newsletter-email");
  const newletterAcceptsMarketing = document.querySelector("#NewsletterFormAcceptsMarketing");
  const newletterAcceptsMarketingPhone = document.querySelector("#NewsletterFormAcceptsMarketingPhone");
  inputFieldEl.forEach((el) => {
    if(el.value.length > 0){
      el.classList.add("on");
    } 
    el.addEventListener('focusin', (e) => {
      e.target.classList.add("on");
    });
    el.addEventListener('change', (e) => {
      if(e.target.value !== ''){
        e.target.classList.add("on");
        e.target.classList.remove('error');
        if(e.target.parentElement.querySelector('.error-message')) e.target.parentElement.querySelector('.error-message').remove();
      } 
    });
    el.addEventListener('focusout', (e) => {
      if(e.target.value === ''){
        e.target.classList.remove("on");
      } else {
        e.target.classList.add("on");
        e.target.classList.remove("error");
        if(e.target.parentElement.querySelector('.error-message')) {
          e.target.parentElement.querySelector('.error-message').remove();
        }
        if(e.target.id === 'newsletter-email'){
          if( !IsEmail(contactEmailInput.value) ){
            e.target.classList.add("error");
            e.target.parentElement.insertAdjacentHTML("beforeend","<span class='error-message'>Please, enter a valid email address.</span>");
          }
        }
      }
    });
  })
  newletterAcceptsMarketing && newletterAcceptsMarketing.addEventListener('change', (e) => {
    if(e.target.checked === true){
      e.target.setAttribute('value', 'true');
      if(e.target.classList.contains('error')) e.target.classList.remove('error');
      if(e.target.parentElement.parentElement.querySelector('.error-message')) e.target.parentElement.parentElement.querySelector('.error-message').remove();
    } else {
      e.target.setAttribute('value', 'false');
      e.target.classList.add('error');
      e.target.parentElement.parentElement.insertAdjacentHTML("beforeend","<span class='error-message'>Please, check the agree to be contacted by email.</span>");
    }
  });
  if(newletterAcceptsMarketingPhone) {
    newletterAcceptsMarketingPhone.addEventListener('change', (e) => {
      if(e.target.checked === true){
        e.target.setAttribute('value', 'true');
        if(e.target.classList.contains('error')) {
          e.target.classList.remove('error');
          if(e.target.parentElement.querySelector('.error-message')) e.target.parentElement.querySelector('.error-message').remove();
        }
      } else {
        e.target.setAttribute('value', 'false');
        if(e.target.classList.contains('error')) {
          e.target.classList.add('error');
          e.target.parentElement.insertAdjacentHTML("beforeend","<span class='error-message'>Please, check the agree to be contacted by phone.</span>");
        }
      }
    });
  }
  const submitFormBtns = document.querySelectorAll('.newsletter-form__button');
    submitFormBtns.forEach((submitFormBtn) => {
      submitFormBtn.addEventListener('click', (event) => {
      event.preventDefault();      
      const myForm = submitFormBtn.closest('form');
      const first_nameEl = myForm.querySelector('[name="contact[first_name]"]');
      const last_nameEl = myForm.querySelector('[name="contact[last_name]"]');
      const emailEl = myForm.querySelector('[name="contact[email]"]');
      const requestCountryEl = myForm.querySelector('[name="contact[country]"]');
      const countryStateEl = myForm.querySelector('.select-state');
      const requestCountry = requestCountryEl ? requestCountryEl.value : '';
      const countryState = countryStateEl ? countryStateEl.value : '';

      let pass = true;
      if( first_nameEl && first_nameEl.value == "" ){
        pass = false;
        if( !first_nameEl.classList.contains("error")){
          first_nameEl.classList.add("error");
          first_nameEl.parentElement.insertAdjacentHTML("beforeend", "<span class='error-message'>Please, enter your first name.</span>");
        }
      }
      if( last_nameEl && last_nameEl.value == '' ){
          pass = false;
        if( !last_nameEl.classList.contains("error")){
          last_nameEl.classList.add("error");
          last_nameEl.parentElement.insertAdjacentHTML("beforeend", "<span class='error-message'>Please, enter your last name.</span>");
        }
      }

      if( emailEl && emailEl.value == "" ){
        pass = false;
        if( !emailEl.classList.contains("error")){
          emailEl.classList.add("error");
          emailEl.parentElement.insertAdjacentHTML("beforeend", "<span class='error-message'>Please, enter your email address.</span>");
        }
      } else if( emailEl && !IsEmail(emailEl.value) ){
          pass = false;
          if( !emailEl.classList.contains("error")){
            emailEl.classList.add("error");
            emailEl.parentElement.insertAdjacentHTML("beforeend", "<span class='error-message'>Please, enter a valid email address.</span>");
          }
      }
      
      const newletterAcceptsMarketing = myForm.querySelector('[name="accepts_marketing"]');
      if( newletterAcceptsMarketing && newletterAcceptsMarketing.value == 'false' ){
        if( !newletterAcceptsMarketing.checked ){
          pass = false;
          if(!newletterAcceptsMarketing.classList.contains('error')) {
            newletterAcceptsMarketing.classList.add("error");
            if(!newletterAcceptsMarketing.parentElement.parentElement.querySelector('.error-message')) {
              newletterAcceptsMarketing.parentElement.parentElement.insertAdjacentHTML("beforeend", "<span class='error-message'>Please, check the agree to be contacted by email.</span>");
            }
          }
        } 
      }
      if (requestCountry === "United States of America" || requestCountry === "China" || requestCountry === "Canada"){
        if (!countryState || countryState === "") {
          pass = false;
          const errorSpan = document.createElement('span');
          errorSpan.classList.add('error-message');
          errorSpan.innerText = 'Please, select the state.';
          const countryStateLabel = countryStateEl.parentElement;
          if (!countryStateLabel.classList.contains('error')) {
            countryStateLabel.classList.add('error');
            countryStateLabel.appendChild(errorSpan);
          }
        }
      }

      if(pass) {
        const first_name = first_nameEl.value;
        const last_name = last_nameEl.value;
        const email = emailEl.value;
        const country = requestCountryEl.value;
        const rm_optin = myForm.querySelector('[name="accepts_marketing"]').value;
        // const rm_optin = myForm.querySelector('#NewsletterFormAcceptsMarketing').value;
        const rm_program = myForm.querySelector('[name="rm_program"]').value;
        const data_privacy = myForm.querySelector('[name="data_privacy"]').value;
        const sub_data_source = myForm.querySelector('[name="sub_data_source"]').value;
        const provinceSelect = countryStateEl;
        const provinceName = provinceSelect ? provinceSelect.getAttribute('name') : '';
        const provinceValue = provinceSelect ? provinceSelect.value : '';

        const data = {
          first_name,
          last_name,
          email,
          country,
          rm_program,
          rm_optin: true,
          data_privacy,
          sub_data_source,
          ...(provinceName === 'province'
          ? { province: provinceValue }
          : provinceName === 'province_cn'
          ? { province_cn: provinceValue }
          : provinceName === 'province_cnd'
          ? { province_cnd: provinceValue }
          : {})
        }

      var ur = window.location.href;
      var newsletter_form_url = 'https://myhub.remy-cointreau.com/apiproxies-shopify-webhook-uat/CRM-NewsLetter?SHOPIFY_PARAM=Newsletter-LXIII-UK&AUTHORIZATION=Z7HsSHkvaYZyH1PujmEfVuUEI9GutbhuCx6iwQawZntxijlB'
      if(ur.includes('https://uk.louisxiii-cognac.com')) {
        newsletter_form_url = 'https://myhub.remy-cointreau.com/apiproxies-shopify-webhook-prod/CRM-NewsLetter?SHOPIFY_PARAM=Newsletter-LXIII-UK&AUTHORIZATION=4ZzUoSdlRBmDk7qahhVtePwI2kjbODYQlFB7TA1ZGs2B9t27'
      }
      const url = newsletter_form_url;
        if (data.rm_optin === "true") {
          data.rm_optin = true;
        } else if (data.rm_optin === "false") {
          data.rm_optin = false;
        }
        if (data.data_privacy === "true") {
          data.data_privacy = true;
        } else if (data.data_privacy === "false") {
          data.data_privacy = false;
        }

        // Spinner
        const subscribeSpan = myForm.querySelector('#Subscribe span');
        const subscribeSmall = myForm.querySelector('#Subscribe small');
        if(subscribeSpan) subscribeSpan.classList.add('d-none');
        if(subscribeSmall) subscribeSmall.classList.remove('d-none');

        fetch(url, {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(function (response) {
          if (response.ok) {
            if(subscribeSpan) subscribeSpan.classList.remove('d-none');
            if(subscribeSmall) subscribeSmall.classList.add('d-none');
            myForm.reset();
            const inputEls = myForm.querySelectorAll('.newsletter-form-inner .input');
            if(inputEls) {
              inputEls.forEach(input => {
                input.classList.remove('error');
                if(input.value === '') input.classList.remove('on');
              })
            }
            const newletterAcceptsMarketingPhone = myForm.querySelector('[name="phone_optin"]');
            const newletterAcceptsMarketing = myForm.querySelector('[name="accepts_marketing"]');
            if(newletterAcceptsMarketingPhone) newletterAcceptsMarketingPhone.setAttribute("value", 'false');
            newletterAcceptsMarketing && newletterAcceptsMarketing.setAttribute("value", 'false');
            dataLayer.push({
              'event': 'newsletter_subscription'
            });
            let date = new Date();
            date.setFullYear(date.getFullYear() + 1); // ajoute 1 an
            document.cookie = "newsletter_subscribed=true; expires=" + date.toUTCString() + "; path=/";
          }

          response.json().then(function (data) {
            const contactHeadersContent = document.querySelectorAll('.newsletter__text, .newsletter-form-inner');
            contactHeadersContent.forEach((item) => item.style.display = 'none');
            const successPanel = myForm.querySelector(".success-wrap");
            successPanel.style.display = 'block';
            successPanel.style.visibility = 'hidden';
            setTimeout(() => {
              successPanel.style.visibility = 'visible';
            }, 800);
          });
        });
      }
    });
  })
  function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
        return false;
    } else{
        return true;
    }
  }
  function repopulateStates(form, Country = "") {
    var selectedCountry = form.querySelector('[name="contact[country]"]').value || Country;
    var stateDropdown = form.querySelector('.select-state');
    stateDropdown.innerHTML = '';

    stateDropdown.disabled = true;
    var defaultOption = document.createElement('option');
    defaultOption.selected = true;
    if (selectedCountry === "United States of America" || selectedCountry === "China" || selectedCountry === "Canada") {
      stateDropdown.parentElement.style.display = 'block';
      
      stateDropdown.classList.remove('on');
      if(selectedCountry === "United States of America") {
        stateDropdown.setAttribute("name","province")
      }else if(selectedCountry === "China"){
        stateDropdown.setAttribute("name","province_cn")
      }else if(selectedCountry === "Canada"){
        stateDropdown.setAttribute("name","province_cnd")
      }

      fetch(stateDropdown.getAttribute('data-state-url'))
        .then(response => response.json())
        .then(data => {
            var defaultOption = document.createElement('option');
            defaultOption.disabled = true;
            defaultOption.value = '';
            defaultOption.selected = true;
            defaultOption.text = '';
            stateDropdown.appendChild(defaultOption);
            stateDropdown.disabled = false;
            if (data.countries.length <= 0) {
                return;
            }
            data.countries.forEach(countrystate => {
                if (countrystate.country === selectedCountry) {
                    countrystate.states.forEach(state => {
                        var option = document.createElement('option');
                        option.value = state;
                        option.text = state;
                        stateDropdown.appendChild(option);
                    })
                }
            })
      })
    
    }
    else {
      stateDropdown.setAttribute("name","");
      stateDropdown.parentElement.style.display = 'none';
      return;
    }

  }

  if( document.URL.endsWith("#nl-sign-up") ) {
    document.querySelector(".newsletter-popup-open-btn").click();
  }
  
  document.querySelector(".newsletter-popup-open-btn").addEventListener("click", function(e){
    e.preventDefault()
    if(!document.URL.endsWith("#nl-sign-up") ){
      window.history.replaceState(null,null,"#nl-sign-up")
    }
  })
})();